import React, { Fragment, useState, useEffect, useRef } from 'react';

export function NameSign() {
    const svgRef = useRef(null);
      const [topAria, setTopAria] = useState("Anna Shepeta");
    
      useEffect(() => {
        let el = svgRef.current;
        if (!el) return undefined;
    
        const initial = el.getAttribute && el.getAttribute('aria-label');
        if (initial) setTopAria(initial);
    
        const observer = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.type === 'attributes' && m.attributeName === 'aria-label') {
              const v = el.getAttribute('aria-label');
              setTopAria(v || '');
            }
          }
        });
    
        observer.observe(el, { attributes: true, attributeFilter: ['aria-label'] });
    
        return () => observer.disconnect();
      }, [svgRef.current]);
    
    return (
        <Fragment>
             <svg ref={svgRef} width="194" height="34" viewBox="0 0 194 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={topAria}>
             <g filter="url(#filter0_d_9_75)">
             <rect x="4" width="186" height="26" rx="13" fill="white"/>
             </g>
             <foreignObject x="4" y="0" width="186" height="26">
                 <div xmlns="http://www.w3.org/1999/xhtml" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                   <div style={{ fontSize: 20, color: 'black', fontFamily: 'Montserrat-Bold, sans-serif' }}>{topAria}</div>
                 </div>
            </foreignObject>
             <defs>
             <filter id="filter0_d_9_75" x="0" y="0" width="194" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
             <feFlood flood-opacity="0" result="BackgroundImageFix"/>
             <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
             <feOffset dy="4"/>
             <feGaussianBlur stdDeviation="2"/>
             <feComposite in2="hardAlpha" operator="out"/>
             <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
             <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9_75"/>
             <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9_75" result="shape"/>
             </filter>
             </defs>
             </svg>
        </Fragment>
    );
}